// extracted by mini-css-extract-plugin
export var actions = "_3m-0";
export var actionsContainer = "_3m-7";
export var border = "_3m-1";
export var childFullHeight = "_3m-f";
export var collapse = "_3m-2";
export var content = "_3m-a";
export var contentChild = "_3m-e";
export var fullscreen = "_3m-c";
export var hasLeftRadius = "_3m-k";
export var headerContainer = "_3m-3";
export var headerRow = "_3m-5";
export var hidePadding = "_3m-b";
export var navCollapsedGap = "_3m-l";
export var noScrollX = "_3m-m";
export var noScrollY = "_3m-n";
export var noTopPadding = "_3m-i";
export var optOutTopPadding = "_3m-d";
export var pageMain = "_3m-j";
export var pageOuter = "_3m-g";
export var pagePadding = "_3m-8";
export var pageScroll = "_3m-9";
export var profile = "_3m-o";
export var profileContainer = "_3m-p";
export var profileImage = "_3m-q";
export var profileMain = "_3m-r";
export var profileSubtitle = "_3m-t";
export var profileTitle = "_3m-s";
export var showLeftPadding = "_3m-h";
export var tabsPortalSlot = "_3m-6";
export var tabsWrapper = "_3m-4";
export var title = "_3m-u";